module.exports = __webpack_public_path__ + "img/IMG_1236.376f2c88.jpeg";